import React, { Fragment } from "react";
import { Link, Image, Text, isEditorActive } from "@sitecore-jss/sitecore-jss-react";
import { CardProps } from "../../types/types";
import { CardModel } from "../../lib/shared-models/card.model";
import "./index.scss";
import RoutableSitecoreLink from "../RoutableSitecoreLink";

const CardGridCard = (props: CardProps) => {
  const model = new CardModel(props);

  const GridCard = () => (
    <Fragment>
      { isEditorActive()
        ? <Image loading="lazy" field={model.image} />
        : <div className="card-grid-card__img-container">
            <Image loading="lazy" field={model.image} />
            <div className="card-grid-card__triangle"></div>
          </div>
      }
      <Text tag="h3" field={model.title} className="card-grid-card__title" />
      <Text tag="p" field={model.subtitle} />
      <div className="card-grid-card__cta">
        <pfe-cta pfe-priority="primary">
          { isEditorActive()
            ? <Link field={model.link} />
            : <span>{model.link?.value?.text}</span>
          }
        </pfe-cta>
      </div>
    </Fragment>
  );

  return (
    <Fragment>
      {isEditorActive()
        ? <div className="card-grid-card">
            <GridCard />
          </div>
        : <Link className="card-grid-card" field={model.link}>
            <GridCard />
          </Link>
      }
    </Fragment>
  );
};

export default CardGridCard;
